module.exports = __webpack_public_path__ + "media/1x1/lt-70975be0.svg";